import { Fragment } from 'react'

import { LoyaltyData } from '../loyalty/loyalty.schema'

type Props = {
  data: LoyaltyData
}

function CustomerLoyaltyInfo({ data }: Props) {
  return (
    <div className="space-y-8">
      <div className="flex flex-col items-center justify-center gap-6">
        <h1 className="text-ion-color-yellow text-3xl font-semibold">
          Loyalty Points
        </h1>
        <div className="text-center">
          <h2 className="text-3xl font-semibold">{`${data.pointsBalance} Points`}</h2>
          <p className="text-xl">
            {data.visitsUntilReward > 0
              ? `Visits Until Reward: ${data.visitsUntilReward}`
              : null}
          </p>
        </div>
      </div>

      <div className="divide-y-2">
        {data.loyaltyRules.map((loyaltyRule) => (
          <Fragment key={loyaltyRule.loyaltyRule.objectId}>
            {loyaltyRule.rewards.map((reward) => (
              <div
                key={JSON.stringify(reward)}
                className="ion-padding-horizontal mx-auto max-w-lg py-6"
              >
                {/* REWARD */}
                <div className="flex items-center gap-x-6">
                  <div className="flex flex-1 flex-col">
                    <span className="text-lg font-semibold">
                      Redeem {reward.text}
                    </span>
                    <span className="text-lg">
                      {reward.pointsBalance} Points
                    </span>
                  </div>
                  <div className="flex-0"></div>
                </div>
                {/* SIXBOX */}
                {loyaltyRule.loyaltyRule.settings.visits > 0 ? (
                  <div className="grid w-full grid-cols-3 gap-0.5 bg-white p-0.5">
                    {Array.from(
                      Array(loyaltyRule.loyaltyRule.settings.visits).keys()
                    ).map((boxItem, index) => {
                      const box = reward.rewardBoxes[index]

                      return (
                        <div key={boxItem} className="min-h-32 bg-slate-300">
                          {box ? (
                            <>
                              {box.kind === 'receipt' ? (
                                <div className="text-ion-color-primary flex min-h-32 flex-col items-center justify-center">
                                  <p className="text-xl font-semibold">
                                    $
                                    {box.receipts.reduce(
                                      (a, c) => a + (c.value ?? 0),
                                      0
                                    )}
                                  </p>
                                  <p className="text-sm">{box.dateString}</p>

                                  <p className="text-sm">
                                    {box.receipts.length > 1
                                      ? `${box.receipts.length} transactions`
                                      : `Trans. #${box.receipts[0].posId}`}
                                  </p>
                                </div>
                              ) : box.kind === 'manual' ? (
                                <div className="text-ion-color-primary flex min-h-32 flex-col items-center justify-center">
                                  <p className="text-xl font-semibold">
                                    ${box.loyaltyPoint.value}
                                  </p>
                                  <p className="text-sm">{box.dateString}</p>
                                </div>
                              ) : null}
                            </>
                          ) : null}
                        </div>
                      )
                    })}
                  </div>
                ) : null}
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export { CustomerLoyaltyInfo }
